import { ApolloError } from '@collinsonx/utils/apollo';

function getErrorMessage(response: ApolloError | unknown) {
  if (response && (response as ApolloError).message) {
    return (response as ApolloError).message;
  }
  return null;
}

export default getErrorMessage;
